<b-button
  :class="buttonClass"
  :variant="variant"
  :size="size"
  @click="onclick($event)"
  :disabled="disabled"
  :title="title"
>
  <!-- 最大化ボタン -->
  <svg
    v-if="iconKey === ICON_KEY.MAXIMUM"
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#1f1f1f"
  >
    <path
      d="M120-120v-200h80v120h120v80H120Zm520 0v-80h120v-120h80v200H640ZM120-640v-200h200v80H200v120h-80Zm640 0v-120H640v-80h200v200h-80Z"
    />
  </svg>

  <!-- 最小化ボタン -->
  <svg
    v-if="iconKey === ICON_KEY.MINIMUM"
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#1f1f1f"
  >
    <path
      d="m136-80-56-56 264-264H160v-80h320v320h-80v-184L136-80Zm344-400v-320h80v184l264-264 56 56-264 264h184v80H480Z"
    />
  </svg>

  <!-- リセットズームボタン -->
  <svg
    v-if="iconKey === ICON_KEY.RESET_ZOOM"
    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"
  >
    <path d="M480-320v-100q0-25 17.5-42.5T540-480h100v60H540v100h-60Zm60 240q-25 0-42.5-17.5T480-140v-100h60v100h100v60H540Zm280-240v-100H720v-60h100q25 0 42.5 17.5T880-420v100h-60ZM720-80v-60h100v-100h60v100q0 25-17.5 42.5T820-80H720Zm111-480h-83q-26-88-99-144t-169-56q-117 0-198.5 81.5T200-480q0 72 32.5 132t87.5 98v-110h80v240H160v-80h94q-62-50-98-122.5T120-480q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q129 0 226.5 79.5T831-560Z"/>
  </svg>

  <!-- 設定ボタン -->
  <svg
    v-if="iconKey === ICON_KEY.CONFIG"
    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"
  >
    <path d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z"/>
  </svg>

  <!-- カーソルAボタン -->
  <svg
    v-if="iconKey === ICON_KEY.CURSOR_A"
    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
    <path d="M276-280h76l40-112h176l40 112h76L520-720h-80L276-280Zm138-176 64-182h4l64 182H414Zm66 376q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm226.5 226.5Q800-347 800-480t-93.5-226.5Q613-800 480-800t-226.5 93.5Q160-613 160-480t93.5 226.5Q347-160 480-160t226.5-93.5Z"/>
  </svg>

  <!-- カーソルBボタン -->
  <svg
    v-if="iconKey === ICON_KEY.CURSOR_B"
    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
    <path d="M340-260h180q60 0 98-35t38-89q0-37-21.5-64T575-487v-2q30-12 47-37.5t17-58.5q0-54-38-85t-104-31H340v441Zm70-254v-125h87q34 0 53.5 16.5T570-576q0 27-19 44.5T501-514h-91Zm0 194v-137h93q36 0 59 19t23 50q0 30-21.5 49T507-320h-97Zm-86 208.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5Zm382.5-142Q800-347 800-480t-93.5-226.5Q613-800 480-800t-226.5 93.5Q160-613 160-480t93.5 226.5Q347-160 480-160t226.5-93.5ZM480-480Z"/>
  </svg>

  <!-- マーカー登録ボタン -->
  <svg
    v-if="iconKey === ICON_KEY.MARKER"
    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
    <path d="m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Zm-286 80h252l-46-46v-314H400v314l-46 46Zm126 0Z"/>
  </svg>

  <!-- 10秒巻き戻りボタン -->
  <svg
    v-if="iconKey === ICON_KEY.SKIP_BACK_LONG"
    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
    <path d="M440-240 200-480l240-240 56 56-183 184 183 184-56 56Zm264 0L464-480l240-240 56 56-183 184 183 184-56 56Z"/>
  </svg>

  <!-- 1秒巻き戻りボタン -->
  <svg
    v-if="iconKey === ICON_KEY.SKIP_BACK_SHORT"
    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
  </svg>

  <!-- 10秒送りボタン -->
  <svg
    v-if="iconKey === ICON_KEY.SKIP_FORWARD_LONG"
    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
    <path d="M383-480 200-664l56-56 240 240-240 240-56-56 183-184Zm264 0L464-664l56-56 240 240-240 240-56-56 183-184Z"/>
  </svg>

  <!-- 1秒送りボタン -->
  <svg 
    v-if="iconKey === ICON_KEY.SKIP_FORWARD_SHORT"
    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
  </svg>
</b-button>
